<template>
    <div v-if="!isMobile" class="list-header clear-float">
        <ul class="cart-table">
            <li>
                <a-checkbox :indeterminate="indeterminate" @change="onCheckAllChange" :checked="checkAll">全选
                </a-checkbox>
            </li>
            <li>课程名称</li>
            <li>原价</li>
            <li>优惠</li>
            <li>操作</li>
        </ul>
    </div>
</template>

<script>
    import {createNamespacedHelpers} from "vuex";
    import common from "../../../mixin/common";

    const {mapGetters} = createNamespacedHelpers('cart');

    export default {
        name: "CartHeader.vue",
        mixins: [common],
        methods: {
            onCheckAllChange() {
                this.$emit('check-all-change')
            },
        },
        computed: {
            ...mapGetters([
                "checkAll",
                "indeterminate",
            ])
        }
    }
</script>

<style scoped lang="less">
    @import '../styles/shopping-cart.less';

    .list-header {
        border: 1px solid #e8e8e8;
        height: 50px;
        line-height: 50px;
        background: #FAFAFA;
    }

</style>
